import React from 'react'
import MaterialSymbol from '../material-symbol'

const ThumbUpAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="thumb_up_alt" {...props} />
))

ThumbUpAlt.displayName = 'ThumbUpAlt'

export default ThumbUpAlt
